import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from './material.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { RouterModule } from '@angular/router';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgScrollbarModule,
    RouterModule,
    NgxExtendedPdfViewerModule,
    NgxMaterialTimepickerModule,
    CKEditorModule,
  ],
  exports: [
    CommonModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgScrollbarModule,
    RouterModule,
    NgxExtendedPdfViewerModule,
    NgxMaterialTimepickerModule,
    CKEditorModule,
  ],
})
export class SharedModule {}

// platformBrowserDynamic().bootstrapModule(SharedModule);
